import { FunctionComponent } from "react";

import { LoadingOverlay } from "@/components";
import { useGetColumnByIdQuery } from "@/pages/Private/redux/list/list.api";

import { PriorityFilterStatus } from "@/enum/list.enum";

import { List } from "@/pages/Private/pages/List/schema/list";

import { EditCustomColumnModal } from "./EditCustomColumnModal";
import { CustomColumnApplyFilters } from "./CustomColumns/customColumnApplyFilters";

export interface EditCustomColumnModalWrapperProps {
	setOpen: (value: boolean) => void;
	open: boolean;
	listId: number;
	list?: List;
	columnId: number;
	filters?: CustomColumnApplyFilters;
	selectedProspectIds?: number[];
	priorityFilterStatus?: PriorityFilterStatus[];
}

export const EditCustomColumnModalWrapper: FunctionComponent<EditCustomColumnModalWrapperProps> = ({
	open,
	setOpen,
	listId,
	columnId,
	list,
	filters,
	selectedProspectIds,
	priorityFilterStatus,
}) => {
	const { data } = useGetColumnByIdQuery(columnId);

	return !data ? (
		<LoadingOverlay />
	) : data ? (
		<EditCustomColumnModal
			column={data}
			columnId={columnId}
			filters={filters}
			list={list}
			listId={listId}
			open={open}
			priorityFilterStatus={priorityFilterStatus}
			selectedProspectIds={selectedProspectIds}
			setOpen={setOpen}
		/>
	) : (
		<></>
	);
};
